import React, { useState, useCallback, useEffect } from "react";
import './decimal-input.scss';
interface DecimalInputProps {
    id: string,
    name: string,
    value: number | string,
    onChange: (value: number) => void,
}

export function DecimalInput({id, name, value, onChange}: DecimalInputProps) {
    const [inputValue, setInputValue] = useState("0.00");

    useEffect(() => {
        setInputValue(decimalFormat(value));
    }, [value, setInputValue]);

    const handleOnBlur = useCallback(() => {
        onChange(parseFloat(inputValue));
    }, [inputValue, onChange]);

    const handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        const reg = /^[0-9.,]/;

        const isValid = reg.test(e.key) || e.key === 'Backspace' || e.key == 'Delete' 
            || e.key == 'ArrowLeft' || e.key == 'ArrowRight';

        console.log(e.key);

        if(!isValid)
            e.preventDefault();
    };

    const handleOnChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(e.target.value);
    }, [setInputValue]);

    return <input type="text" id={id} className="decimal-input" name={name} onClick={(e) => e.currentTarget.select()} 
               onKeyDown={handleOnKeyDown} onBlur={handleOnBlur} value={inputValue} onChange={handleOnChange} />;
} 

export function decimalFormat(val: any, round: number = 2) {
    return val ? parseFloat(val).toFixed(round) : "0,00";
}

export function parseToDecimal(val: string) {
    const finalVal = val == "" ? "0.00" : val;
    return parseFloat(finalVal.replace(",", "."));
}
